<template>
  <div id="app">
    <a-locale-provider :locale="locale">
      <router-view/>
    </a-locale-provider>
  </div>
</template>
<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import {LocaleProvider} from 'ant-design-vue'
export default {
  components:{'a-locale-provider':LocaleProvider},
  data() {
      return {
        locale: zhCN,
      };
    },
}
</script>


<style>
.w-content {
  width: 1280px;
  margin: 0 auto;
}
#app {
 
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

</style>
